<!-- src/App.vue -->
<template>
  <div id="app">
    <router-view />  <!-- Este componente es esencial para mostrar las rutas -->
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
